/* eslint-disable @typescript-eslint/no-explicit-any */
import { Text, View } from "@react-pdf/renderer";
import React from "react";
import { EvidencePart, ProgramSkill } from "@interfaces/Interfaces";
import { getDisplayTitleForPDFExport } from "@utils/stringUtils";

type Props = {
  definition: EvidencePart;
  isPDF: boolean;
  isDisplay: boolean;
  pdfStyles: any;
  preselectedSkill?: ProgramSkill | null;
};

const SkillsDisplay: React.FC<Props> = (props) => {
  if (props.isPDF || props.isDisplay) {
    return (
      <View>
        <Text style={props.pdfStyles.reflectionHeader}>{getDisplayTitleForPDFExport(props.definition)}</Text>
        <Text style={props.pdfStyles.evidenceDate}>{props.preselectedSkill?.Name}</Text>
      </View>
    );
  }

  if (props.isDisplay) {
    return (
      <div className="readEvidenceBlock">
        <div className="readEvidenceHeader">{props.definition["Display Title"] ?? props.definition.Name}</div>
        <div className="readEvidenceText">{props.preselectedSkill?.Name}</div>
        <div className="h-[1px] w-full bg-grey-30 mt-4" />
      </div>
    );
  }

  return (
    <div>
      <div className="text-acc-20px max-[500px]:text-acc-17px font-acc-600 leading-[1.41] tracking-[-0.2px] text-grey-90">
        {props.preselectedSkill?.Name}
      </div>
    </div>
  );
};

export default SkillsDisplay;
